export const PIXEL_ID = '908258408929715';

export function trackInitiateCheckout(): void {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'MEGAPACK BIBLIOTECOLOGÍA LISTO',
    value: 19990,
    currency: 'ARS',
  });
}
